<section class="blogposts-shell">
  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (sites.length) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Markdown publishing</p>
          <h2>Blogposts</h2>
          <p class="table-note">Write, tag, and publish markdown-only blogposts.</p>
        </div>
        <button type="button" class="accent" [disabled]="loading || !!deletingBlogpostId" (click)="createBlogpost()">New blogpost</button>
      </header>

      @if (tagFilter.tags.length) {
        <section class="active-filters-band" aria-label="Applied blogpost filters">
          <div class="active-filters-copy">
            <p class="active-filters-label">Filters</p>
            <div class="active-filters-list">
              @for (tag of tagFilter.tags; track tag) {
                <button
                  type="button"
                  class="content-tag tag-filter-chip is-active"
                  [disabled]="loading || !!deletingBlogpostId"
                  [attr.aria-pressed]="true"
                  (click)="toggleTagFilter(tag)">
                  {{ tag }}
                </button>
              }
            </div>
          </div>
          <button type="button" class="ghost small clear-filters-button" [disabled]="loading || !!deletingBlogpostId" (click)="clearFilters()">
            Clear all
          </button>
        </section>
      }

      @if (loading) {
        <p class="empty-state">Loading blogposts...</p>
      } @else if (blogposts.length) {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Slug</th>
                <th scope="col">Tags</th>
                <th scope="col">State</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              @for (blogpost of blogposts; track blogpost.id) {
                <tr>
                  <td class="title-cell">
                    <strong class="title-text" [title]="blogpost.title">{{ blogpost.title || 'Untitled blogpost' }}</strong>
                    <span class="summary-text" [title]="blogpost.summary">{{ blogpost.summary || 'No summary' }}</span>
                  </td>
                  <td class="slug-cell"><code class="slug-text" [title]="blogpost.slug">{{ blogpost.slug }}</code></td>
                  <td class="tags-cell">
                    @if (blogpost.tags.length) {
                      <div class="content-tags">
                        @for (tag of blogpost.tags; track tag) {
                          <button
                            type="button"
                            class="content-tag tag-filter-chip"
                            [class.is-active]="isFilterActive(tag)"
                            [disabled]="loading || !!deletingBlogpostId"
                            [attr.aria-pressed]="isFilterActive(tag)"
                            [title]="tag"
                            (click)="toggleTagFilter(tag)">
                            {{ tag }}
                          </button>
                        }
                      </div>
                    } @else {
                      <span class="empty-tags">None</span>
                    }
                  </td>
                  <td class="state-cell">
                    <span class="state-pill" [class.state-pill--published]="blogpost.published">
                      {{ blogpost.published ? 'Published' : 'Draft' }}
                    </span>
                  </td>
                  <td class="actions-cell">
                    <div class="row-actions">
                      <button type="button" class="ghost small icon-button" aria-label="Edit blogpost" title="Edit blogpost" [disabled]="!!deletingBlogpostId" (click)="openBlogpost(blogpost.id)">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M4 20h4.75L19 9.75 14.25 5 4 15.25V20Zm2-2v-1.92l8.25-8.25 1.92 1.92L7.92 18H6ZM18.37 3.88l1.75 1.75a1.5 1.5 0 0 1 0 2.12l-.92.92-3.87-3.88.92-.91a1.5 1.5 0 0 1 2.12 0Z" />
                        </svg>
                      </button>
                      <button type="button" class="danger small icon-button" [attr.aria-label]="deletingBlogpostId === blogpost.id ? 'Deleting blogpost' : 'Delete blogpost'" [attr.title]="deletingBlogpostId === blogpost.id ? 'Deleting blogpost' : 'Delete blogpost'" [disabled]="!!deletingBlogpostId" (click)="deleteBlogpost(blogpost.id)">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 6h2v8h-2V9Zm4 0h2v8h-2V9ZM7 9h2v8H7V9Zm1 12a2 2 0 0 1-2-2V8h12v11a2 2 0 0 1-2 2H8Z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="empty-state">No blogposts yet for this site. Create the first markdown post to open the editor.</p>
      }
    </section>
  } @else {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Blogposts</p>
          <h2>No sites available</h2>
        </div>
      </header>
      <p class="empty-state">Create a site first before managing blogposts.</p>
    </section>
  }
</section>
